const Bill = () =>
  import(
    /* webpackChunkName: "financial-bill" */ '@/pages/financial/commercial-banking/bill.vue'
  )

export default {
  path: 'bill',
  meta: {
    label: 'bill',
    auth: true
  },
  component: {
    name: 'Bill',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BillReport',
      path: '',
      meta: {
        label: 'report'
      },
      component: Bill
    }
  ]
}
